import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    tableWrapper: {
      padding: "0",
      margin: "0",
      "& .MuiPaper-outlined": {
        border: 0
      },
      "& .MuiTable-root": {
        "& .MuiTableRow-root": {
          height: "36px",
          "& .MuiTableCell-root": {
            paddingTop: "4px",
            paddingBottom: "4px",
            "& .MuiTableSortLabel-root": {
              "&:hover": {
                color: "#bbdefb"
              }
            },
            "& .MuiTableSortLabel-active": {
              color: "#bbdefb",
              "& .MuiTableSortLabel-icon": {
                color: "#bbdefb"
              }
            }
          }
        }
      }
    },
    topHeader: {
      borderBottom: "1px solid #9c9c9c",
      fontSize: "0.5 rem",
      padding: "10px 20px 10px 10px"
    },
    toolbar: {
      display: "flex",
      flexDirection: "row-reverse",
      alignItems: "center",
      padding: "0px"
    },
    detailTable: {
      padding: 20,
      backgroundColor: theme.palette.grey[200]
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    }
  })
);
